<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path d="M4 7h16"/>
        <path d="M9 7V4h6v3"/>
        <path d="m6 7 1 13h10l1-13"/>
        <path d="M10 11v5M14 11v5"/>
    </svg>
</template>
